"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPickupPoints = void 0;
class GetPickupPoints {
    constructor(PickupPointsService) {
        this.PickupPointsService = PickupPointsService;
    }
    execute(request) {
        return this.PickupPointsService.getPickupPoints(request);
    }
}
exports.GetPickupPoints = GetPickupPoints;
